import http from '../services/http';

export default {
  namespaced: true,

  state: {
    pageTitle: null,
  },

  mutations: {
    CLEAR_ALL(state) {
      state.pageTitle = null;
    },
    SET_PAGE_TITLE(state, data) {
      state.pageTitle = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    findByType({ commit }, type) {
      return http(`/page_titles/${type}`)
        .then((response) => response.body)
        .then((item) => {
          commit('SET_PAGE_TITLE', item);
        });
    },

    save(_, {
      type, ...data
    }) {
      const request = http(`/page_titles/${type}`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
